import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "@i18n";
import { Icon } from "@syarahtech/ui";
import WarrantyOptionItem from "./WarrantyOptionItem";
import Markdown from "markdown-to-jsx";
import warrantyIcon from "./assets/warranty-3d-icon.png";
import { twMerge } from "tailwind-merge";
export default function DesktopWarrantySelector(_ref) {
  var _data$items, _displaySelected$head, _displaySelected$head2, _displaySelected$head3, _displaySelected$head4, _data$items2, _displaySelected$head5, _displaySelected$head6, _displaySelected$head7;
  var data = _ref.data,
    selectedItem = _ref.selectedItem,
    selectedId = _ref.selectedId,
    onConfirm = _ref.onConfirm,
    onListOpened = _ref.onListOpened;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    tShort = _useTranslation.tShort;
  var _useState = useState(true),
    isExpanded = _useState[0],
    setIsExpanded = _useState[1];
  var _useState2 = useState(selectedId),
    stagingId = _useState2[0],
    setStagingId = _useState2[1];
  var displaySelected = data.selected;
  var isNoWarrantyState = !displaySelected;
  var badgedItem = isNoWarrantyState ? data.items.find(function (i) {
    return !!i.badge;
  }) : null;
  var lastItemId = (_data$items = data.items[data.items.length - 1]) === null || _data$items === void 0 ? void 0 : _data$items.id;
  var isHighestSelected = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === lastItemId;
  var displayTitle = (_displaySelected$head = displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head2 = displaySelected.header) === null || _displaySelected$head2 === void 0 ? void 0 : _displaySelected$head2.title) !== null && _displaySelected$head !== void 0 ? _displaySelected$head : tShort("warranty/no_warranty_title", {
    ns: "web_checkout_cash"
  });
  var displaySubtitle = (_displaySelected$head3 = displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head4 = displaySelected.header) === null || _displaySelected$head4 === void 0 ? void 0 : _displaySelected$head4.subtitle) !== null && _displaySelected$head3 !== void 0 ? _displaySelected$head3 : badgedItem ? "".concat(tShort("warranty/no_warranty_subtitle", {
    ns: "web_checkout_cash"
  }), " ").concat(badgedItem.title) : null;
  var selectedIndex = data.items.findIndex(function (i) {
    return i.id === stagingId;
  });
  var handleOpen = function handleOpen() {
    setStagingId(selectedId);
    setIsExpanded(true);
    onListOpened === null || onListOpened === void 0 ? void 0 : onListOpened();
  };
  var handleSelect = function handleSelect(id) {
    setStagingId(id);
    setIsExpanded(false);
    onConfirm(id);
  };
  var selectedItemFullData = data === null || data === void 0 ? void 0 : (_data$items2 = data.items) === null || _data$items2 === void 0 ? void 0 : _data$items2.find(function (ele) {
    return (ele === null || ele === void 0 ? void 0 : ele.id) === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full  py-4"
  }, /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false,
    mode: "wait"
  }, !isExpanded ? /*#__PURE__*/React.createElement(motion.div, {
    key: "trigger",
    initial: {
      opacity: 0,
      scale: 0.98
    },
    animate: {
      opacity: 1,
      scale: 1
    },
    exit: {
      opacity: 0,
      scale: 0.98
    },
    transition: {
      duration: 0.18,
      ease: "easeOut"
    }
  }, isNoWarrantyState ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 rounded-xl border border-solid border-[#d6c6f5] bg-[#F1F6FC] px-4 py-3 no-warranty"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement("img", {
    src: warrantyIcon,
    width: 40,
    height: 45,
    alt: "Warranty Icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start flex-1 min-w-0"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[#00143c] font-bold text-[13px] leading-6 break-words w-full text-start"
  }, tShort("warranty/empty_desktop_title", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#8E47E0] text-[12px] leading-5 break-words w-full text-start"
  }, tShort("warranty/empty_desktop_subtitle", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: handleOpen,
    className: "flex-shrink-0 flex items-center gap-1 rounded-[4px] bg-primary-new px-3 py-2 cursor-pointer border-none hover:bg-[#0a0a90] active:bg-[#08087a] transition-colors"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-white text-[12px] leading-tight whitespace-nowrap"
  }, tShort("warranty/empty_cta", {
    ns: "web_checkout_cash"
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 rounded-lg bg-[#F1F6FC] px-4 py-5  normal-warranty"
  }, displaySelected !== null && displaySelected !== void 0 && displaySelected.icon ? /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement("img", {
    src: displaySelected.icon,
    width: 40,
    height: 45
  })) : /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 w-10 h-10 rounded-full bg-[#8E47E0]/10 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--verified-outline",
    className: "text-[#8E47E0]",
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start flex-1 min-w-0"
  }, displayTitle && /*#__PURE__*/React.createElement("div", {
    className: "pb-1 flex text-[14px] items-center"
  }, (displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head5 = displaySelected.header) === null || _displaySelected$head5 === void 0 ? void 0 : _displaySelected$head5.title_prefix) && /*#__PURE__*/React.createElement("span", {
    className: "pe-[2px]"
  }, displaySelected.header.title_prefix + " "), /*#__PURE__*/React.createElement("p", {
    className: "leading-6 break-words w-fit px-1 text-start text-[14px]",
    style: _objectSpread(_objectSpread({}, (displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head6 = displaySelected.header) === null || _displaySelected$head6 === void 0 ? void 0 : _displaySelected$head6.title_color) && {
      color: displaySelected.header.title_color
    }), (displaySelected === null || displaySelected === void 0 ? void 0 : (_displaySelected$head7 = displaySelected.header) === null || _displaySelected$head7 === void 0 ? void 0 : _displaySelected$head7.title_highlight_background) && {
      backgroundColor: displaySelected.header.title_highlight_background
    })
  }, /*#__PURE__*/React.createElement(Markdown, null, displayTitle))), displaySubtitle && /*#__PURE__*/React.createElement("p", {
    className: twMerge("text-[#00143c] leading-5 break-words w-full text-start text-xs")
  }, /*#__PURE__*/React.createElement(Markdown, null, displaySubtitle))), /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, isHighestSelected && !isNoWarrantyState ? /*#__PURE__*/React.createElement("button", {
    onClick: handleOpen,
    className: "cursor-pointer border-none bg-transparent p-0 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--edit-square-outline",
    className: "text-primary-new px-1",
    width: 6,
    height: 6
  })) : /*#__PURE__*/React.createElement("button", {
    onClick: handleOpen,
    className: "flex items-center gap-1 rounded-[4px] bg-primary-new px-3 py-2 cursor-pointer border-none hover:bg-[#0a0a90] active:bg-[#08087a] transition-colors"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-white text-[12px] leading-tight whitespace-nowrap"
  }, tShort("warranty/extend_now", {
    ns: "web_checkout_cash"
  })))))) : /*#__PURE__*/React.createElement(motion.div, {
    key: "options",
    initial: {
      height: 0,
      opacity: 0
    },
    animate: {
      height: "auto",
      opacity: 1
    },
    exit: {
      height: 0,
      opacity: 0
    },
    transition: {
      duration: 0.28,
      ease: [0.4, 0, 0.2, 1]
    },
    style: {
      overflow: "hidden"
    },
    className: "bg-[#F1F6FC] pt-4 pb-5 rounded-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 px-4 mb-2 inner-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 ms-2"
  }, /*#__PURE__*/React.createElement("img", {
    src: (displaySelected === null || displaySelected === void 0 ? void 0 : displaySelected.icon) || warrantyIcon,
    width: 40,
    height: 45
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-3 pt-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-[#00143C] text-[20px] leading-6"
  }, displaySelected !== null && displaySelected !== void 0 && displaySelected.inner_title ? displaySelected === null || displaySelected === void 0 ? void 0 : displaySelected.inner_title : tShort("warranty/extend_title", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#00143C] text-[14px] leading-5 pt-1"
  }, displaySelected === null || displaySelected === void 0 ? void 0 : displaySelected.inner_subtitle))), /*#__PURE__*/React.createElement(motion.div, {
    className: "flex flex-col gap-3 mx-4",
    initial: "hidden",
    animate: "visible",
    variants: {
      visible: {
        transition: {
          staggerChildren: 0.06,
          delayChildren: 0.05
        }
      },
      hidden: {}
    }
  }, data.items.map(function (item, itemIndex) {
    return /*#__PURE__*/React.createElement(motion.div, {
      key: item.id,
      variants: {
        hidden: {
          opacity: 0,
          y: 10
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.25,
            ease: "easeOut"
          }
        }
      }
    }, /*#__PURE__*/React.createElement(WarrantyOptionItem, {
      item: item,
      isSelected: item.id === stagingId,
      onSelect: handleSelect,
      size: "md",
      showBadge: true,
      animateGlow: Boolean(item.badge) && selectedIndex < itemIndex
    }));
  })))));
}